export const validateError = (error: unknown): string | undefined =>
    typeof error === 'string' || typeof error === 'undefined' ? error : undefined;
